import { AnyObject } from '@data-driven-forms/react-form-renderer/dist/cjs/common';
import { DBFormSchema, plainTextSection, confettiField, fieldAlertSection } from '../field-helpers';
import { StepNames } from '.';
import { FIELD_NAMES } from '../..';
import { CheckCircleFill } from 'react-bootstrap-icons';
import React from 'react';

const { successFields } = FIELD_NAMES;

export const successTabFields = (schema: DBFormSchema, nextStep?: StepNames | AnyObject) => {
  const successTab = schema?.success_tab;

  if (!successTab || successTab?.hideTab) return null;

  return {
    title: successTab?.label ?? 'Success',
    name: StepNames.Success,
    nextStep: successTab?.nextStep ?? nextStep,
    fields: [
      confettiField(successFields.confetti_banner, 12),
      fieldAlertSection(successFields.alertText, schema?.[successFields.alertText], {
        sizes: { md: 12 },
        type: 'success',
        icon: React.createElement(CheckCircleFill),
        style: { fontWeight: '400' }
      }),
      plainTextSection(successFields.successMsg, schema?.[successFields.successMsg], {
        sizes: { md: 12 },
        style: { fontWeight: '400' }
      }),
      plainTextSection(successFields.successInstructions, schema?.[successFields.successInstructions], {
        sizes: { md: 12 },
        style: { fontWeight: '400' }
      }),
      plainTextSection(successFields.successRequestStatus, schema?.[successFields.successRequestStatus], {
        sizes: { md: 12 },
        style: { fontWeight: '400' }
      }),
      plainTextSection(successFields.successContactUs, schema?.[successFields.successContactUs], {
        sizes: { md: 12 },
        style: { fontWeight: '400' }
      })
    ].filter(Boolean)
  };
};
